import React from 'react';

import { Chip, HeroImageContainer } from './HeroImage.style';
import { type AccentImage } from '../Subsection';

export const HeroImage = ({ content }: { content: AccentImage }) => {
  const { image, name } = content;
  return (
    <HeroImageContainer>
      {image.mobile}
      {name && <Chip>{name}</Chip>}
    </HeroImageContainer>
  );
};
